import { call, put, all, takeLatest } from 'redux-saga/effects';

import serviceMentor from 'services/mentor';
import actions from './actions';
import types from './types';

export function* mentorEdit(action) {
  const {
    callback,
    payload: { id, ...mentorData },
  } = action;
  try {
    const response = yield call(serviceMentor.editMentor, {
      id,
      ...mentorData,
    });
    yield put(actions.mentorEditSucceeded(response.data));
    if (callback) callback();
  } catch (e) {
    yield put(
      actions.mentorEditFailed({
        message: (e.response && e.response.data) || e.message,
      })
    );
  }
}

export function* mentorSelectedFetch(action) {
  const { payload } = action;
  try {
    const response = yield call(serviceMentor.getMentor, {
      id: payload.id,
    });
    yield put(actions.mentorSelectedFetchSucceeded(response.data));
  } catch (e) {
    yield put(
      actions.mentorSelectedFetchFailed({
        message: (e.response && e.response.data) || e.message,
      })
    );
  }
}

function* mentorSaga() {
  yield all([
    takeLatest(types.MENTOR_EDIT, mentorEdit),
    takeLatest(types.MENTOR_SELECTED_FETCH, mentorSelectedFetch),
  ]);
}

export default mentorSaga;
